import { BrowserRouter, Route, Routes } from "react-router-dom"
import Login from "./pages/login"
import { Toaster } from "react-hot-toast"
import Dashboard from "pages/dashboard"
import Sidebar from "components/Sidebar/Sidebar"
import UserList from "pages/userList"
import Modal from "components/Modal"
import { ProtectedRoutes, ProtectedRoutesforLoggedIn, OnboardingRoute, PermissionRoute } from "utils/function"
import Onboarding from "pages/onboarding"
import Categories from "pages/categories"
import RestaurantPOS from "pages/dashboard/RestaurantPOS"
import CollectionPoints from "pages/collectionPoints"
import FoodItems from "pages/foodItems"
import Customers from "pages/customers"
import ManageAccounts from "pages/manageAccounts"
import TimeSlots from "pages/timeSlots"
import AddFoodItems from "pages/foodItems/AddFoodItems"
import Orders from "pages/orders"
import Calendar from "pages/calendar"
import Tables from "pages/tables"
import Serve from "pages/serve"
import PastOrders from "pages/pastOrders"
import { OrderProvider } from "context/OrderContext"
import OrderDeatilsNew from "pages/NewOrderOrderDeatils"
import AddItemToOrder from "pages/AddItemOrder"
import Stations from "pages/stations"
import ManageSettings from "pages/settings/ManageSettings"
import Profile from "pages/profile"
import Analytics from "pages/analytics"
import ManagePhotos from "pages/managePhotos"
import RestaurantTimings from "pages/restaurantTimings"
import ManageReviews from "pages/manageReviews"
import Inventory from "pages/inventory"
import Offers from "pages/offers"
import SupportTickets from "pages/supportTickets"
import CreateTicketScreen from "pages/supportTickets/CreateTicketScreen"
import TicketDetailScreen from "pages/supportTickets/TicketDetailScreen"
import CashManagement from "pages/cashManagement"

const Router = () => {
    return (
        <>
            <BrowserRouter basename={process.env.REACT_APP_BASE_ROUTE}>
                <OrderProvider>
                    <Routes>

                        <Route element={<ProtectedRoutesforLoggedIn />}>
                            <Route path="/login" element={<Login />} />
                        </Route>

                        {/* Onboarding page for users who have logged in but not completed profile */}
                        <Route element={<OnboardingRoute />}>
                            <Route path="/onboarding" element={<Onboarding />} />
                        </Route>

                        {/* If user is logged in, they can access protected routes */}
                        <Route element={<ProtectedRoutes />}>
                            <Route path="/dashboard" element={<Analytics />} />
                            <Route path='/' element={<RestaurantPOS />} />
                            <Route path='/users' element={<UserList />} />
                            <Route path='/categories' element={<Categories />} />
                            <Route element={<PermissionRoute permissionKey="permission_collection_point" />}>
                                <Route path='/collection-point' element={<CollectionPoints />} />
                            </Route>
                            <Route path='/food-items' element={<FoodItems />} />
                            <Route path='/food-items/manage-food-items' element={<AddFoodItems />} />
                            <Route path='/customers' element={<Customers />} />
                            <Route path='/manage-accounts' element={<ManageAccounts />} />
                            <Route element={<PermissionRoute permissionKey="permission_table_booking" />}>
                                <Route path='/time-slots' element={<TimeSlots />} />
                                <Route path='/tables' element={<Tables />} />
                            </Route>
                            <Route path='/orders' element={<Orders />} />
                            <Route path='/orders/past-orders' element={<PastOrders />} />
                            <Route element={<PermissionRoute permissionKey="permission_pos_calender_view" />}>
                                <Route path='/calendar' element={<Calendar />} />
                            </Route>
                            <Route element={<PermissionRoute permissionKey="permission_pos_chef_panel" />}>
                                <Route path='/serve' element={<Serve />} />
                            </Route>
                            <Route path='/order-details' element={<OrderDeatilsNew />} />
                            <Route path='/add-item-order' element={<AddItemToOrder />} />
                            <Route path='/stations' element={<Stations />} />
                            <Route path='/manage-settings' element={<ManageSettings />} />
                            <Route path='/profile' element={<Profile />} />
                            <Route path='/manage-photos' element={<ManagePhotos />} />
                            <Route path='/restaurant-timings' element={<RestaurantTimings />} />
                            <Route path='/manage-reviews' element={<ManageReviews />} />
                            <Route element={<PermissionRoute permissionKey="permission_pos_inventory" />}>
                                <Route path='/inventory' element={<Inventory />} />
                            </Route>
                            <Route path='/offers' element={<Offers />} />
                            <Route path='/cash-management' element={<CashManagement />} />
                            <Route path='/support-tickets' element={<SupportTickets />} />
                            <Route path='/support-tickets/create' element={<CreateTicketScreen />} />
                            <Route path='/support-tickets/:id' element={<TicketDetailScreen />} />
                        </Route>

                    </Routes>
                </OrderProvider>
                <Modal />
            </BrowserRouter>
            <Toaster />
        </>
    )
}

export default Router
